import type { IPaginatorLocale } from './types';

export const UI_PAGINATOR_LOCALE_ES: IPaginatorLocale = {
  PAGINATOR: {
    LOADING: 'Cargando',
    SHOWING_ROWS: 'Mostrando',
    TO: '-',
    OF: 'de',
  },
};

export const UI_PAGINATOR_LOCALE_EN: IPaginatorLocale = {
  PAGINATOR: {
    LOADING: 'Loading',
    SHOWING_ROWS: 'Showing',
    TO: '-',
    OF: 'of',
  },
};
